module.exports = __webpack_public_path__ + "static/media/kia.68920616.png";